export var LoadStatus;
(function (LoadStatus) {
  LoadStatus["notload"] = "notload";
  LoadStatus["loading"] = "loading";
  LoadStatus["loaded"] = "loaded";
  LoadStatus["failed"] = "failed";
})(LoadStatus || (LoadStatus = {}));
export var defaultConfig = {
  key: 'f97efc35164149d0c0f299e7a8adb3d2',
  AMap: {
    version: '2.0',
    plugins: []
  },
  AMapUI: {
    version: '1.1',
    plugins: []
  },
  Loca: {
    version: '2.0.0'
  }
};